/* KS Rebuy cart widget — collapse, teaser, and upsell gap headline.
 *
 * Behavior:
 * - Collapsing no longer hides the widget: CSS shows the first
 *   recommendation as a compact teaser row (see ks-rebuy-cart-collapse.css).
 * - The collapsed preference expires after 7 days (legacy 'true' values
 *   are treated as expired immediately).
 * - While the cart is below the active threshold, the widget auto-expands
 *   on drawer open and the title becomes a gap headline. When the drawer
 *   campaign card is active, the gap uses that scheme (minimum / offer
 *   thresholds on eligible items). Copy follows the 台美直郵 shipping tier
 *   policy ($10 international shipping at minimum threshold). Otherwise it
 *   falls back to the theme free-shipping limit vs cart subtotal.
 */
(function () {
  if (window.__ksRebuyCartCollapse) return;
  window.__ksRebuyCartCollapse = true;

  const ENHANCED_ATTR = 'data-ks-rebuy-collapse-enhanced';
  const COLLAPSED_CLASS = 'ks-rebuy-collapsed';
  const COLLAPSE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  const TITLES = {
    emptyCampaignPrefix: '滿 ',
    emptyCampaignSuffix: ' 享 $10 國際運費，從人氣商品開始',
    gapPrefix: '再加 ',
    gapSuffix: ' 享 $10 國際運費，順手帶一件',
    success: '已享 $10 國際運費，順手再帶一件',
    fallback: '順手帶一件',
  };
  const CAMPAIGN_SLOT_SELECTOR = '#ks-free-shipping-progress-slot';
  const TITLE_RETRY_DELAYS_MS = [0, 50, 200, 500, 900, 1500];

  /** Latest campaign totals from ks:cart-state:updated (ahead of DOM swaps). */
  let campaignSnapshot = null;

  function getContainer() {
    return document.querySelector('[data-ks-rebuy-collapse]');
  }

  function getWidgetId() {
    const container = getContainer();
    return (container && container.dataset.rebuyWidgetId) || '288503';
  }

  function getStorageKey() {
    return 'ks-rebuy-cart-' + getWidgetId() + '-collapsed';
  }

  function getSessionKey() {
    return getStorageKey() + '-session';
  }

  function isCollapsed() {
    let raw = null;

    try {
      raw = localStorage.getItem(getStorageKey());
    } catch (_e) {
      return false;
    }

    if (!raw) return false;

    // Legacy plain 'true' (no timestamp): expire immediately so everyone
    // who ever collapsed the widget sees it again once.
    if (raw === 'true') {
      clearStoredCollapse();
      return false;
    }

    try {
      const parsed = JSON.parse(raw);
      if (!parsed || parsed.collapsed !== true) return false;

      const age = Date.now() - Number(parsed.ts || 0);
      if (!Number.isFinite(age) || age > COLLAPSE_TTL_MS) {
        clearStoredCollapse();
        return false;
      }

      return true;
    } catch (_e) {
      clearStoredCollapse();
      return false;
    }
  }

  function clearStoredCollapse() {
    try {
      localStorage.removeItem(getStorageKey());
    } catch (_e) { /* noop */ }
  }

  function setCollapsed(collapsed) {
    try {
      if (collapsed) {
        localStorage.setItem(
          getStorageKey(),
          JSON.stringify({ collapsed: true, ts: Date.now() })
        );
        sessionStorage.setItem(getSessionKey(), 'collapsed');
      } else {
        localStorage.removeItem(getStorageKey());
        sessionStorage.removeItem(getSessionKey());
      }
    } catch (_e) { /* storage may be unavailable; degrade gracefully */ }
  }

  function collapsedThisSession() {
    try {
      return sessionStorage.getItem(getSessionKey()) === 'collapsed';
    } catch (_e) {
      return false;
    }
  }

  function getCartDrawer() {
    return (
      document.querySelector('cart-drawer#cart-drawer') ||
      document.querySelector('#cart-drawer') ||
      document.querySelector('.drawer--cart')
    );
  }

  function getWidget() {
    return document.querySelector('#rebuy-widget-' + getWidgetId());
  }

  // --- Upsell gap (drawer campaign scheme, else theme free-shipping limit) ---

  function getCampaignSlot() {
    return document.querySelector(CAMPAIGN_SLOT_SELECTOR);
  }

  function readCampaignFields(source) {
    if (!source) return null;

    const isElement = typeof source.dataset !== 'undefined';

    return {
      state: ((isElement ? source.dataset.ksState : source.state) || 'empty'),
      eligibleTotal: Number(
        isElement ? source.dataset.ksEligibleTotal : source.eligibleTotal
      ) || 0,
      threshold: Number(
        isElement ? source.dataset.ksThreshold : source.threshold
      ) || 0,
      minimumThreshold: Number(
        isElement ? source.dataset.ksMinimumThreshold : source.minimumThreshold
      ) || 0,
      offerProgressEnabled: isElement
        ? source.dataset.ksEnableOfferProgress === 'true'
        : source.offerProgressEnabled === true,
    };
  }

  function getCampaignData() {
    const slot = getCampaignSlot();
    const fromSlot = readCampaignFields(slot);
    const fromSnapshot = readCampaignFields(campaignSnapshot);

    if (!fromSlot && !fromSnapshot) return null;

    const merged = Object.assign({}, fromSnapshot || {}, fromSlot || {});

    if (fromSlot && fromSnapshot) {
      if (fromSnapshot.eligibleTotal > fromSlot.eligibleTotal) {
        merged.eligibleTotal = fromSnapshot.eligibleTotal;
        merged.state = fromSnapshot.state || fromSlot.state;
      }

      merged.offerProgressEnabled = fromSlot.offerProgressEnabled;
      merged.minimumThreshold =
        fromSlot.minimumThreshold || fromSnapshot.minimumThreshold;
      merged.threshold = fromSlot.threshold || fromSnapshot.threshold;
    }

    return merged;
  }

  function getFreeShippingLimitCents() {
    const container = getContainer();
    const fromContainer = container && Number(container.dataset.ksFreeShippingLimit);
    if (Number.isFinite(fromContainer) && fromContainer > 0) {
      return fromContainer;
    }

    const fromDrawer = document.querySelector('.drawer--cart [data-free-shipping-limit]');
    if (fromDrawer) {
      const limit = Number(fromDrawer.getAttribute('data-free-shipping-limit'));
      if (Number.isFinite(limit) && limit > 0) {
        return limit;
      }
    }

    return 20000;
  }

  function getCartTotalCents() {
    const totalEl = document.querySelector('.drawer--cart [data-cart-total]');
    if (!totalEl) return null;

    const raw = totalEl.getAttribute('data-cart-total');
    if (raw === null || raw === '') return null;

    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function gapTitle(cents) {
    return {
      text: TITLES.gapPrefix + formatMoney(cents) + TITLES.gapSuffix,
      hasGap: true,
    };
  }

  function resolveTitle() {
    const slot = getCampaignSlot();
    const campaign = getCampaignData();

    if (slot || campaign) {
      const state = (campaign && campaign.state) || 'empty';
      const eligible = (campaign && campaign.eligibleTotal) || 0;
      const minThreshold = (campaign && campaign.minimumThreshold) || 0;
      const threshold = (campaign && campaign.threshold) || 0;
      const offerOn = Boolean(campaign && campaign.offerProgressEnabled);

      if (state === 'empty') {
        const minCents = minThreshold > 0 ? minThreshold : 9900;
        return {
          text:
            TITLES.emptyCampaignPrefix +
            formatMoney(minCents) +
            TITLES.emptyCampaignSuffix,
        };
      }

      if (state === 'minimum') {
        const gap = minThreshold - eligible;
        if (gap > 0) return gapTitle(gap);
      }

      if (state === 'offer' && offerOn) {
        const gap = threshold - eligible;
        if (gap > 0) return gapTitle(gap);
      }

      if (state === 'offer' || state === 'max') {
        return { text: TITLES.success };
      }
    }

    const total = getCartTotalCents();
    const limit = getFreeShippingLimitCents();

    if (total !== null && limit) {
      const gap = limit - total;
      if (gap > 0) return gapTitle(gap);
      if (total >= limit) return { text: TITLES.success };
    }

    return { text: TITLES.fallback };
  }

  function formatMoney(cents) {
    // Whole dollars, rounded up so "add $X more" is never short.
    return '$' + Math.ceil(Number(cents || 0) / 100).toLocaleString(undefined, {
      maximumFractionDigits: 0,
    });
  }

  function updateTitle(widget) {
    const title = widget && widget.querySelector('.primary-title');
    if (!title) return;

    const expected = resolveTitle().text;

    // Never leave Rebuy's English default ("You may also like").
    if (title.textContent !== expected) {
      title.textContent = expected;
    }
  }

  function scheduleTitleRefresh(widget) {
    if (!widget) return;

    TITLE_RETRY_DELAYS_MS.forEach(function (delay) {
      window.setTimeout(function () {
        updateTitle(widget);
        applyCollapsedState(widget);
      }, delay);
    });
  }

  function watchTitle(widget) {
    const title = widget && widget.querySelector('.primary-title');
    if (!title || title.hasAttribute('data-ks-title-watched')) return;

    title.setAttribute('data-ks-title-watched', 'true');

    const observer = new MutationObserver(function () {
      const expected = resolveTitle().text;
      if (title.textContent !== expected) {
        title.textContent = expected;
      }
    });

    observer.observe(title, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  // --- Collapse state ---

  function shouldRenderCollapsed() {
    if (!isCollapsed()) return false;

    // Below the active threshold the widget auto-expands, unless the user
    // collapsed it manually during this session.
    if (resolveTitle().hasGap && !collapsedThisSession()) {
      return false;
    }

    return true;
  }

  function applyCollapsedState(widget) {
    if (!widget) return;

    const collapsed = shouldRenderCollapsed();
    widget.classList.toggle(COLLAPSED_CLASS, collapsed);

    const title = widget.querySelector('.primary-title');
    if (title) {
      title.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }

    updateTitle(widget);
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (_e) {
      return false;
    }
  }

  function toggleWidget(widget) {
    const nextCollapsed = !widget.classList.contains(COLLAPSED_CLASS);
    widget.classList.toggle(COLLAPSED_CLASS, nextCollapsed);
    setCollapsed(nextCollapsed);

    const title = widget.querySelector('.primary-title');
    if (title) {
      title.setAttribute('aria-expanded', nextCollapsed ? 'false' : 'true');
    }

    // On user-initiated expand, center the grid in the drawer viewport so
    // the newly revealed items aren't below the fold. (Not done in
    // applyCollapsedState, so drawer opens / auto-expand never scroll.)
    if (!nextCollapsed) {
      window.requestAnimationFrame(function () {
        widget.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'center',
        });
      });
    }
  }

  function onTitleActivate(event) {
    const title = event.currentTarget;
    const widget = title.closest('#rebuy-widget-' + getWidgetId());
    if (!widget) return;

    event.preventDefault();
    toggleWidget(widget);
  }

  function onTitleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onTitleActivate(event);
    }
  }

  function enhanceWidget(widget) {
    if (!widget || widget.hasAttribute(ENHANCED_ATTR)) return;

    const title = widget.querySelector('.primary-title');
    if (!title) return;

    widget.setAttribute(ENHANCED_ATTR, 'true');
    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');
    title.setAttribute('aria-expanded', shouldRenderCollapsed() ? 'false' : 'true');
    title.classList.add('ks-rebuy-collapse__title');

    title.addEventListener('click', onTitleActivate);
    title.addEventListener('keydown', onTitleKeydown);

    watchTitle(widget);
    applyCollapsedState(widget);
    scheduleTitleRefresh(widget);
  }

  function scanAndEnhance() {
    const widget = getWidget();
    if (widget) {
      enhanceWidget(widget);
      applyCollapsedState(widget);
      updateTitle(widget);
      scheduleTitleRefresh(widget);
    }
  }

  function scheduleScan() {
    window.clearTimeout(window.__ksRebuyCollapseTimer);
    window.__ksRebuyCollapseTimer = window.setTimeout(scanAndEnhance, 50);
  }

  function startObserver() {
    // Scope observation to the drawer and the widget placeholder; the Rebuy
    // widget only ever renders inside these containers.
    const targets = [getCartDrawer(), getContainer()].filter(Boolean);

    if (targets.length === 0) return;

    const observer = new MutationObserver(scheduleScan);

    targets.forEach((target) => {
      observer.observe(target, { childList: true, subtree: true });
    });

    scanAndEnhance();
  }

  function bindCartEvents() {
    const events = [
      'theme:cart:change',
      'theme:cart-drawer:open',
      'rebuy.add',
      'rebuy.change',
      'rebuy:cart.add',
      'rebuy:cart.change',
      'cart:refresh',
    ];

    events.forEach((name) => {
      document.addEventListener(name, scheduleScan);
    });

    // Campaign progress recalculated: cache fresh totals and refresh headline.
    document.addEventListener('ks:cart-state:updated', function (event) {
      campaignSnapshot = event.detail || null;
      scheduleScan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startObserver();
      bindCartEvents();
    });
  } else {
    startObserver();
    bindCartEvents();
  }
})();
